/**
 * quoteBadge.js — the "Devis" counter in the header (sections/header.liquid).
 *
 * Shows the number of LINES in the quote basket kept in localStorage
 * ("quoteItems") next to the Devis button, the way the cart button shows its
 * item count. Lines, not units: quote quantities run in the hundreds.
 *
 * Updates on page load, when another tab changes the basket ("storage"
 * event) and when a script on this page writes it (custom "lcf:quote:changed"
 * event, dispatched by productQuote.js, collectionQuote.js, quotePage.js and
 * sections/devis-clear.liquid). Items added by the store-locator map bundles
 * are picked up on the next page load, since the map redirects afterwards.
 * Loaded site-wide from layout/theme.liquid (round 2, 2026-09-10).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'quoteItems';
  var CHANGE_EVENT = 'lcf:quote:changed';
  var BADGE_SELECTOR = '.js-quote-count';

  function lineCount() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return 0;
      return stored.filter(function (item) { return item && item.variantId != null; }).length;
    } catch (error) {
      return 0;
    }
  }

  function update() {
    var badges = document.querySelectorAll(BADGE_SELECTOR);
    if (!badges.length) return;
    var count = lineCount();
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(count);
      badges[i].classList.toggle('hidden', count === 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  window.addEventListener('storage', function (event) {
    if (event.key === null || event.key === STORAGE_KEY) update();
  });
  document.addEventListener(CHANGE_EVENT, update);
})();
